export enum AdminPharmaciesTableColumnTitle {
  Name = "Ime",
  Adress = "Adresa",
  Active = "Aktivna",
  Options = "",
}
